<template>
  <DialogCard>
    <template #title>
      Imaging Centers
    </template>
    <template #text>
      <p>
        Let us augment your imaging data with the latest in computational solutions.
      </p>
      <ul>
        <li>
          We help imaging centers differentiate their services by easily storing and
          visualizing large-scale imaging datasets.
        </li>
        <li>
          Our automated visualization helps you save time and increase accuracy.
        </li>
        <li>
          We make it easy to compare functional magnetic images over time and
          integrate our services with your existing PACS system.
        </li>
        <li>
          Discover what openVOXEL can do for imaging centers. Send us a message to
          <a href="mailto:openvoxelorg@gmail.com">openvoxelorg@gmail.com</a>.
        </li>
      </ul>
    </template>
  </DialogCard>
</template>

<script>
import DialogCard from '@/layout/BottomDrawer/DialogCard.vue';

export default {
  name: 'OpenvoxelImagingCentersDialog',
  components: {
    DialogCard,
  },
};
</script>
